import React, { useCallback, useState } from 'react';

import useToggle from '@lyearn/core/hooks/useToggle';
import { useTranslation } from '@lyearn/i18n';
import { InputBase, Typography } from '@lyearn/ui';

interface TabsLabelProps {
  isActive: boolean;
  defaultValue?: string;
  id: string;
  onBlur: (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

const TabLabel: React.FC<TabsLabelProps> = (props) => {
  const { t } = useTranslation();
  const { defaultValue, id, onBlur: _onBlur, isActive } = props;
  const [showInput, { toggle }] = useToggle(isActive);
  const [name, setName] = useState(defaultValue || '');

  const onBlur = useCallback(
    (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      _onBlur(event);
      toggle();
    },
    [_onBlur, toggle],
  );

  return (
    <div className="w-full pe-28">
      {showInput ? (
        <InputBase
          autoFocus
          className="label-01"
          defaultValue={name}
          id={id}
          placeholder={t('Lygo:Menu.tabs.UntitledTab')}
          onBlur={onBlur}
          onChange={(event) => setName(event.target.value)}
        />
      ) : (
        <Typography
          className={'label-01 w-full self-start truncate normal-case text-start'}
          variant="body-long-01"
          onClick={isActive ? toggle : undefined}>
          {name || t('Lygo:Menu.tabs.UntitledTab')}
        </Typography>
      )}
    </div>
  );
};

export default TabLabel;
